document.addEventListener('DOMContentLoaded', function () {
  initLazyVideos();
});

const initLazyVideos = () => {
  var lazyVideos = [].slice.call(
    document.querySelectorAll('video.hw-lazy-video')
  );

  if ('IntersectionObserver' in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.addEventListener('play', function () {
            video.target.style.removeProperty('aspect-ratio');
          });

          video.target.load();
          video.target.classList.remove('hw-lazy-video');
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
};

export { initLazyVideos };
